export default __webpack_public_path__ + "static/media/MEETRA_CERTIFICATE_5.53243035.jpg";